export default {
  additional_questions: 'elite',
  default_gender: 'female',
  tags: [],
  is_job_title_mandatory: false
}
